<template>
  <v-dialog
    v-model="dialog"
    transition="dialog-bottom-transition"
    persistent
    max-width="800px"
    >

    <v-card>
      <v-card-title class="pa-4 headline white--text primary">
        New Option
      </v-card-title>
      <v-card-text class="pa-0">

        <v-tabs v-model="currentTab">
          <v-tab @click="changeTab(OptionSourceDocType.Web)">
            <v-icon left>mdi-link</v-icon>
            From URL
          </v-tab>
          <v-tab @click="changeTab(OptionSourceDocType.None)">
            <v-icon left>mdi-pencil</v-icon>
            Manual
          </v-tab>

          <v-tab-item>
            <v-card flat>
              <v-card-text>

                <form class="mt-4">
                  <v-text-field
                    v-model="newOptionModel.url"
                    :error-messages="urlErrors"
                    label="URL"
                    placeholder="Provide a URL and let Decidedly build the option for you"
                    @input="$v.newOptionModel.url.$touch()"
                    @blur="$v.newOptionModel.url.$touch()"
                  ></v-text-field>
                </form>

              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>

                <form class="mt-4">
                  <v-text-field
                    v-model="newOptionModel.name"
                    :error-messages="nameErrors"
                    :counter="100"
                    label="Name"
                    required
                    placeholder="Give this option a name"
                    @input="$v.newOptionModel.name.$touch()"
                    @blur="$v.newOptionModel.name.$touch()"
                  ></v-text-field>
                </form>

              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>


      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>

        <v-btn
          v-if="newOptionModel.sourceDocType === OptionSourceDocType.Web"
          color="primary"
          :disabled="$v.newOptionModel.url.$invalid || creating"
          :loading="creating"
          @click="createNewOption()"
        >
          Build Option
        </v-btn>

        <v-btn
          v-if="newOptionModel.sourceDocType === OptionSourceDocType.None"
          color="primary"
          :disabled="$v.newOptionModel.name.$invalid || creating"
          :loading="creating"
          @click="createNewOption()"
        >
          Build Option
        </v-btn>

        <v-btn text @click="$v.$reset(); dialog = false;">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Constants from '../constants.json'
// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app'
// Load the auth feature into the firebase namespace.
import 'firebase/auth'
import axios from 'axios'

// vuelidate
import { validationMixin } from 'vuelidate'
import { url, required, maxLength } from 'vuelidate/lib/validators'

// Custom mixins
import guid from '@/mixins/DecidedlyGUID.js'

import { mapState, mapGetters } from 'vuex'

// import OptionReviewCard from '@/components/OptionReviewCard.vue'

export default {
  name: 'CreateOptionDialog',
  mixins: [validationMixin, guid],
  validations: {
    newOptionModel: {
      url: { required, url },
      name: { required, maxLength: maxLength(100) }
    }
  },
  props: {
    value: Boolean,
    // decisionId: String,
    // decisionTaxon: String,
    // decisionCriteria: Object
  },
  mounted: function () {
    this.resetDialog()
  },
  computed: {
    ...mapGetters('decision',{
      criteriaList: 'criteriaList'
    }),
    ...mapState({
      decisionId: state => state.decision.decisionId,
      decisionTaxon: state => state.decision.currentTaxon
    }),
    dialog: {
      // getter
      get: function () {
        return this.value
      },
      // setter
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    },
    urlErrors () {
      const errors = []
      if (!this.$v.newOptionModel.url.$dirty) return errors
      !this.$v.newOptionModel.url.url && errors.push('Must be valid URL')
      !this.$v.newOptionModel.url.required && errors.push('A URL is required.')
      return errors
    },
    nameErrors () {
      const errors = []
      if (!this.$v.newOptionModel.name.$dirty) return errors
      !this.$v.newOptionModel.name.maxLength && errors.push('Name must be at most 100 characters long')
      !this.$v.newOptionModel.name.required && errors.push('Name is required.')
      return errors
    },
    // criteriaList () {
    //     let res = []
    //     if (this.decisionCriteria) {
    //       res = Object.keys(this.decisionCriteria).map( (key) => {
    //           const criteriaItem = { ...this.decisionCriteria[key] }
    //           criteriaItem.id = key
    //           return criteriaItem
    //       })
    //     }
    //     res.sort((a, b) => a.order - b.order)
    //     //res.sort((a, b) => a.name.localeCompare(b.name))
    //     return res
    // }
  },
  data () {
    return {
      newOptionModel: {},
      OptionSourceDocType: {
        None: 0,
        Web: 1,
        Doc: 2
      },
      currentTab: 0,
      creating: false
    }
  },
  watch: {
    // whenever question changes, this function will run
    value: function (newValue) {
      this.$v.$reset()
      if (newValue === true) {
        this.resetDialog()
      }
    }
  },
  methods: {
    resetDialog: function() {
      this.creating = false
      this.newOptionModel = {id: this.genGUID(), name: '', criteriaValues: {}, criteriaValueOptions: {}, sourceDocType: this.OptionSourceDocType.Web}
      this.currentTab = 0
      this.$nextTick(() => { this.$v.$reset() })
    },
    changeTab: function (newSourceDocType) {
      this.$set(this.newOptionModel, 'sourceDocType', newSourceDocType)
      // this.newOptionModel.sourceDocType = newSourceDocType
      this.newOptionModel.name = ''
      this.newOptionModel.url = ''
      this.$v.newOptionModel.name.$touch()
      this.$v.newOptionModel.url.$touch()
      // this.$nextTick(() => { this.$v.$reset() })
    },
    createNewOption: async function () {
      if (!this.newOptionModel.sourceDocType && this.newOptionModel.url) {
        // Default to web
        this.newOptionModel.sourceDocType = this.OptionSourceDocType.Web
      }

      if (!this.newOptionModel.sourceDocType) {
        this.newOptionModel.sourceDocType = this.OptionSourceDocType.None
      }

      this.creating = true

      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const postNewOptionsURL = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}/options`
      this.newOptionModel.decisionTaxon = this.decisionTaxon

      const res = await axios.post(postNewOptionsURL, this.newOptionModel, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      })

      if (res && res.status === 200) {

        if (res.data && res.data.optionId) {
          this.newOptionModel.id = res.data.optionId
        }
        if (this.newOptionModel.url) {
          this.newOptionModel.scrapeState = Constants.SCRAPE_STATES.unscraped

          // Start scraping options with urls
          this.startOptionScraping()
        }

        // Notify the world we created a new option model
        // this.$emit('onSaved', this.newOptionModel)
        this.$nextTick(() => { this.$v.$reset() })
        // Close the new option type dialog
        this.dialog = false
      }
    },
    startOptionScraping: async function () {
      // First clear on selected values and re-sync criteria. They might have changed and this could be the second build (if back button was used)
      // this.syncNewOptionModelWithDecisionCriteria()
      // this.option.screenGrabId = null
      const userUID = firebase.auth().currentUser ? firebase.auth().currentUser.uid : null;
      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      //const scrapeNewOptionsURL = `${Constants.API_BASE_PATH}/urlscrape`
      ///options/:optionId/criteria/scrape
      const scrapeNewOptionsURL = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}/options/${this.newOptionModel.id}/criteria/scrape`
      const scrapeCriteriaList = this.criteriaList.filter(criteriaItem => !criteriaItem.ignoreInScrape)

      const scrapeBody = {
        url: encodeURI(this.newOptionModel.url),
        criteria: scrapeCriteriaList
      }
      if (userUID) {
        scrapeBody.uid = userUID // used to find user specific synonyms
      }

      // console.log(`Calling scrape post ${JSON.stringify(scrapeBody)}`)
      // this.scrapingOption = true
      // const self = this
      axios.post(scrapeNewOptionsURL, scrapeBody, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
